import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import Popper from '../../Popper';
import MediaChip from '../MediaChip';
import { format } from 'date-fns';
function CalendarCell(props) {
    const { disabled = false, isToday = false, date, schedule, isEditable, setShowschedule, showSchedule, cellType, source, } = props;
    let chips = [];
    schedule === null || schedule === void 0 ? void 0 : schedule.map((item) => {
        var _a, _b;
        if (((_a = item === null || item === void 0 ? void 0 : item.creatives) === null || _a === void 0 ? void 0 : _a.length) && source.includes('tag-creative')) {
            item.creatives.map((artwork) => {
                chips.push(Object.assign(Object.assign({}, item), { type: 'artwork' }));
            });
        }
        if (((_b = item === null || item === void 0 ? void 0 : item.poe) === null || _b === void 0 ? void 0 : _b.length) && source.includes('poe')) {
            item.poe.map((poe) => chips.push(Object.assign(Object.assign({}, item), { type: 'poe' })));
        }
        chips.push(Object.assign(Object.assign({}, item), { type: 'schedule' }));
    });
    return (_jsxs(Box, Object.assign({ onMouseEnter: () => {
            setShowschedule(date);
        }, onMouseLeave: () => {
            setShowschedule(null);
        }, sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        } }, { children: [_jsxs(Stack, Object.assign({ direction: cellType === 'day' ? 'column' : 'row-reverse', justifyContent: "space-between", mb: 2, position: 'relative', sx: {
                    cursor: 'pointer',
                    borderBottom: cellType === 'week' ? '1.5px solid #DCDFE4' : '',
                    height: cellType === 'week' ? '75px' : '',
                } }, { children: [cellType === 'day' && (_jsx(Typography, Object.assign({ variant: "h3", textAlign: "center", width: "50px" }, { children: format(new Date(date), 'iii') }))), _jsx(Typography, Object.assign({ variant: "h2", display: "flex", alignItems: "center", justifyContent: "center", fontSize: '20px', sx: {
                            opacity: disabled ? 0.5 : 1,
                            backgroundColor: isToday ? '#AC9DFF' : '',
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            padding: cellType === 'day' || cellType === 'week' ? 5 : 0,
                        } }, { children: date.getDate() })), isToday &&
                        !(isEditable &&
                            !disabled &&
                            date.toDateString() === (showSchedule === null || showSchedule === void 0 ? void 0 : showSchedule.toDateString())) && (_jsx(Typography, Object.assign({ variant: "h5", sx: {
                            position: cellType === 'week' ? 'absolute' : 'static',
                            top: '-30px',
                            left: '5px',
                            width: '50px',
                        }, textAlign: 'center' }, { children: "Today" })))] })), _jsxs(Box, Object.assign({ sx: {
                    padding: cellType === 'week' ? '10px' : '0px',
                    paddingTop: cellType === 'month' ? '20px' : '0px',
                } }, { children: [chips === null || chips === void 0 ? void 0 : chips.map((item, i) => i < 2 && _jsx(MediaChip, { schedule: item, source: source }, `${i}`)), (chips === null || chips === void 0 ? void 0 : chips.length) > 2 && (_jsx(Popper, Object.assign({ content: _jsx(Box, Object.assign({ sx: { maxHeight: '200px', overflow: 'auto' } }, { children: chips.map((item, i) => i >= 2 && (_jsx(MediaChip, { schedule: item, source: source }, `${i}`))) })) }, { children: _jsxs(Typography, Object.assign({ variant: "h6", color: "primary", noWrap: true, sx: { cursor: 'pointer' }, width: "50px" }, { children: ["+", chips.length - 2, " More"] })) })))] }))] })));
}
export default CalendarCell;
